// extracted by mini-css-extract-plugin
export default {"group-option":"cyvy1MAa","groupOption":"cyvy1MAa"};